import React from 'react';
import NewHome from './components/NewHome';
import HomeAbout from './components/homeabout';
import Event from './components/event';
import ContactUs from './components/contactus';
import Homecount from './components/homecount';
import CounterArea from './components/CounterArea';
import VideoArea  from './components/VideoArea ';
import ServiceArea from './components/ServiceArea';
import DonationArea from './components/DonationArea';
import TestimonialArea from './components/TestimonialArea ';
import EventArea from './components/BlogArea ';
import ProcessArea from './components/ProcessArea';
import CtaArea from './components/CtaArea';
//import BlogArea from './components/BlogArea ';
import AboutArea from './components/AboutArea';
import TeamArea from './components/TeamArea';
import PriceArea from './components/PriceArea';
import Ourpartner from './components/ourpartner';















const IndexPage = () => {

  return (
  <>



 <Homecount/>
 <AboutArea/>
<CounterArea/>
<ServiceArea/>
<VideoArea />
{/* <TeamArea/> */}
{/* <DonationArea/> */}
{/* <TestimonialArea/> */}
{/* <EventArea/> */}
{/* <ProcessArea/> */}
{/* <PriceArea/> */}
<CtaArea/>
<Ourpartner/>
{/* <BlogArea/> */}


 

{/* <DownloadPDf/> */}

  </>
  );};

  export default IndexPage;